import { Client } from 'typesense'

export const typesenseClient = new Client({
  nodes: [
    {
      host: import.meta.env.VITE_TYPESENSE_HOST,
      port: 443,
      protocol: 'https',
    },
  ],
  apiKey: import.meta.env.VITE_TYPESENSE_API_KEY!,
  connectionTimeoutSeconds: 5,
  timeoutSeconds: 10,
  numRetries: 1,
})
